import React from 'react';
import styles from './columns.module.css';

export default ({ columns }) => (
  <div className={styles.block}>
    <div className={styles.wrapper}>
      {
        columns.map((column, key) => {
          return <div className={styles.column} key={key} dangerouslySetInnerHTML={{__html: column.node.html}}/>
        })
      }
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/columns/Columns.js